import { AppellateMasterData } from "types/models/appellateMaster/AppellateMasterApp";

export const GET_APPELLATE = "GET_APPELLATE";
export const SET_APPELLATE_DATA = "SET_APPELLATE_DATA";


export interface GetAppellateAction {
  type: typeof GET_APPELLATE;
  payload: { data: AppellateMasterData[]; total: number };
}

export interface SetAppellateDetailAction {
  type: typeof SET_APPELLATE_DATA;
  payload: AppellateMasterData;
}


export type AppellateMasterActionTypes =
  | GetAppellateAction
  | SetAppellateDetailAction
  
